export interface Role {
  id?: string;
  name: string;
  description?: string;
  composite?: boolean;
  clientRole?: boolean;
  containerId?: string;
  attributes?: Record<string, string>;
  realmMappings?: any[];
}

export class User {
  id?: string;
  userId?: string;
  organizationId?: string;
  username: string;
  name?: string;
  organizationName?: string;
  preferred_username?: string;
  given_name?: string;
  family_name?: string;
  enabled: boolean;
  email: string;
  emailVerified: boolean;
  firstName: string;
  lastName: string;
  password: string;
  admin: boolean;
  attributes: Record<string, string>;
  groups: string[];
  realmAdmin?: boolean;

  constructor() {
    this.username = "";
    this.enabled = false;
    this.email = "";
    this.emailVerified = false;
    this.firstName = "";
    this.lastName = "";
    this.password = "";
    this.admin = false;
    this.attributes = { organizationId: '2d7a1fa1-1717-4710-a215-37a67b8d2d2e', organizationName: 'Engineering' };
    this.groups = ['Engineering'];
    // this.credentials = []; // {type:'password',value:'',temporary:false}
  }
}
